/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 *
 * dashboardSummary — this module's "Needs you" contributions to the operations
 * hub (Home): programs awaiting review, programs ready to score, and active
 * programs whose window has ended (so they can be moved to scoring).
 */

import { listPrograms } from "./incentiveService.js";
import { STATUS } from "./constants.js";

export async function getDashboardSummary() {
  let programs = [];
  try { programs = await listPrograms(); } catch { return { kpis: [], signals: [] }; }

  const today = new Date().toISOString().slice(0, 10);
  const signals = [];

  for (const p of programs) {
    const who = p.distributor_name || "Program";
    // Item 230. A program whose packet never actually reached the distributor is
    // the most urgent thing this module can tell you: the rep believes the
    // conversation has started and it has not. It gets its own signal rather
    // than hiding behind the status, which still reads "Sent".
    if (p.send_status === "failed") {
      signals.push({
        key: `inc-undelivered-${p.id}`, severity: "warn",
        title: `“${p.name}” was never emailed`, detail: `${who} · the packet did not reach the distributor`,
        to: `/incentives/${p.id}`, actionLabel: "Fix",
      });
    }
    if (p.status === STATUS.PENDING_REVIEW) {
      signals.push({
        key: `inc-review-${p.id}`, severity: "warn",
        title: `“${p.name}” needs review`, detail: `${who} · awaiting approval`,
        to: "/incentives", actionLabel: "Review",
      });
    } else if (p.status === STATUS.SCORING) {
      signals.push({
        key: `inc-score-${p.id}`, severity: "info",
        title: `“${p.name}” is ready to score`, detail: `${who} · enter results`,
        to: "/incentives", actionLabel: "Score",
      });
    } else if (p.status === STATUS.ACTIVE && p.end_date && p.end_date < today) {
      signals.push({
        key: `inc-ended-${p.id}`, severity: "warn",
        title: `“${p.name}” has ended`, detail: `${who} · ended ${p.end_date} — move to scoring`,
        to: "/incentives", actionLabel: "Open",
      });
    }
  }

  return { kpis: [], signals };
}
